module.exports = __webpack_public_path__ + "static/media/item2.59f4b741.png";